export default "<p> The complete list of offerings.</p>"